import { z } from 'zod';
import { searchTermSchema } from './common.js';
export const projectSearchSchema = z.object({
    q: searchTermSchema,
    limit: z.coerce.number().int().min(1).max(20).default(5),
});
//# sourceMappingURL=search.js.map